/**
 * Initialisation centralisée des Product Cards
 * Ce fichier contient la logique d'initialisation des product cards
 * qui peut être réutilisée partout dans l'application
 */

// Fonction globale pour initialiser une product card
window.initProductCard = function (productCard) {
  if (!productCard || productCard.hasAttribute("data-initialized")) return;
  productCard.setAttribute("data-initialized", "true");

  // Gestion des variants pour les product cards
  const variantSelectors = productCard.querySelectorAll(
    ".product-card-variant-selector"
  );

  variantSelectors.forEach(function (selector) {
    selector.addEventListener("change", function () {
      // Retirer la classe active de tous les labels du même groupe
      const groupName = this.name;
      const productForm = productCard.querySelector("form");

      if (!productForm) return;

      const allLabelsInGroup = productCard.querySelectorAll(
        `input[name="${groupName}"] + label`
      );
      allLabelsInGroup.forEach((label) => label.classList.remove("active"));

      // Ajouter la classe active au label sélectionné
      const selectedLabel = this.nextElementSibling;
      if (selectedLabel) {
        selectedLabel.classList.add("active");
      }

      // Mettre à jour l'ID de la variante dans le formulaire
      const variantId = this.getAttribute("data-variant-id");
      const variantPrice = this.getAttribute("data-variant-price");
      const hiddenInput = productForm.querySelector(".product-card-variant-id");
      if (hiddenInput && variantId) {
        hiddenInput.value = variantId;
      }

      // Mettre à jour le prix de la variante dans le formulaire
      const priceElement = productCard.querySelector(
        ".product-card__price-value"
      );

      if (priceElement && variantPrice) {
        priceElement.textContent = variantPrice;
      }

      // Mettre à jour le prix de la variante dans le footer de la product card
      const priceElementModified = productCard.parentElement.querySelector(
        ".product-card__footer .product-card__price-value"
      );

      if (priceElementModified && variantPrice) {
        priceElementModified.textContent = variantPrice;
      }
    });
  });

  // Gestion de l'ajout au panier pour les product cards
  const addToCartBtn = productCard.querySelector(".product-card-add-btn");
  const productForm = productCard.querySelector("form");

  if (addToCartBtn && productForm) {
    addToCartBtn.addEventListener("click", function (event) {
      console.log(
        "addToCartBtn clicked",
        productCard.getAttribute("data-unique-id")
      );
      event.preventDefault();
      event.stopPropagation();

      // Désactiver le bouton pendant la requête
      this.setAttribute("disabled", "disabled");

      const formData = new FormData(productForm);

      // Ajouter le produit au panier
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: formData.get("id"),
          quantity: parseInt(formData.get("quantity")),
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // Réactiver le bouton
          this.removeAttribute("disabled");

          // Déclencher l'événement d'ajout au panier
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: data,
                quantity: parseInt(formData.get("quantity")),
              },
            })
          );
        })
        .catch((error) => {
          console.error("Erreur lors de l'ajout au panier:", error);
          this.removeAttribute("disabled");
        });
    });
  }
};

// Initialiser toutes les product cards au chargement de la page
document.addEventListener("DOMContentLoaded", function () {
  // Initialiser les product cards existantes
  const productCards = document.querySelectorAll(".product-card");
  productCards.forEach(function (card) {
    window.initProductCard(card);
  });

  // Observer les nouvelles product cards ajoutées dynamiquement
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function (node) {
          // Vérifier si le noeud est un élément DOM
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Vérifier si c'est une product card
            if (node.classList && node.classList.contains("product-card")) {
              window.initProductCard(node);
            }
            // Vérifier les product cards à l'intérieur du noeud
            const cards = node.querySelectorAll(".product-card");
            cards.forEach(function (card) {
              window.initProductCard(card);
            });
          }
        });
      }
    });
  });

  // Observer tout le body pour les nouvelles product cards
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
